import React, {Fragment} from "react";
import Select from "react-select";

import {formatGroupLabel} from "./DropdownDataProviders";

const getCurrentText = ( value, data, options ) =>
{
    if ( data.length === 0 )
    {
        return '' ;
    }
    else
    {
        if ( options.isRawValue !== true )
        {
            if ( value.value === undefined )
            {
                const entry = data.find ( element => element.value == value );

                return entry.label  ;
            }
            else
            {
                const entry = data.find ( element => element.value == value.value );

                return entry.label  ;
            }
        }
        else
        {
            if ( value.value === undefined )
            {
                const entry = data.find ( element => element.value == value );

                return entry.label  ;
            }
            else
            {
                const entry = data.find ( element => element.value == value.value );

                return entry.label  ;
            }
        }
    }
}

const getEntryWithValue = ( current, dropdownData, isRawValue ) =>
{
    if ( isRawValue !== true )
    {
        if ( Array.isArray(current))
        {
            const entry = dropdownData.filter ((listentry) =>
            {
                const match = current.find ( (alreadyset) => {
                    return alreadyset == listentry.value;
                });

                if ( match !== undefined )
                {
                    return true ;
                }
            })

            return entry ;
        }
        else
        {
            if ( current.value === undefined )
            {
                const entry = dropdownData.find ( element => element.value == current );

                return entry  ;
            }
            else
            {
                const entry = dropdownData.find ( element => element.value == current.value );

                return entry  ;
            }
        }
    }
    else
    {
        const entry = dropdownData.find ( element => element.value == current.value );

        return entry  ;
    }
}

export const renderDropdownReadOnly = (value, callbackOnChange, data, options) =>
{
    let style = {
        borderColor: '#d8e5ed',
        paddingLeft: '14px',
        color: '#428bcd'
    };

    return (
        <Fragment>
            <div
                className = 'form-control'
                style = {style} >
                {getCurrentText(value, data, options === undefined ? {} : options)}
            </div>
        </Fragment>
    )
}

/*

Options can include:

isSearchable : true / false     Allows searching in the dropdown
isMulti : true / false          Allows multipl e entries to be selected
isRawValue: true / false        This will return an object representing the more complex data if we need extra information
                                from the selected item, instead of just the value of the ID field
 */
export const renderDropdown = ( value, callbackOnChange, data, options) =>
{
    const onChange = ( value, option ) =>
    {
        switch ( option.action )
        {
            case 'select-option':

                const rvalue = options.isRawValue === true ? value : value.value ;

                callbackOnChange ( rvalue ) ;

                break ;
            default:
                throw new Error('Unknown option') ;
        }
    }

    const isSearchable = options === null || options === undefined ? false : options.isSearchable === true ;
    const isClearable = options === null || options === undefined ? false : options.isClearable === true ;
    const isMulti = options === null || options === undefined ? false : options.isMulti === true ;

    return (
        <Select
            onChange={onChange}
            options={data}
            value={getEntryWithValue(value, data, options.isRawValue)}
            id={'type'}
            isSearchable={isSearchable}
            isClearable={isClearable}
            isMulti={isMulti}
            formatGroupLabel={formatGroupLabel} />

    )
}

